import { render, staticRenderFns } from "./DomainList.vue?vue&type=template&id=66ac04ea&scoped=true"
import script from "./DomainList.vue?vue&type=script&lang=js"
export * from "./DomainList.vue?vue&type=script&lang=js"
import style0 from "./DomainList.vue?vue&type=style&index=0&id=66ac04ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ac04ea",
  null
  
)

export default component.exports